/**
 * @internal
 */
export enum EnvironmentEnum {
  'local' = 'local',
  'contract-local' = 'contract-local',
  'midback-local' = 'midback-local',
  'dvp' = 'dvp',
  'test' = 'test',
  'rec2' = 'rec2',
  'rec3' = 'rec3',
  'rec6' = 'rec6',
  'ppd' = 'ppd',
  'prd' = 'prd',
}
